/************************
 * EVENTOS PARA PLAYERS *
 ************************/

export function analisisPartidoJornada(season_id, matchday) {
  dataLayer.push({
    event: 'analisis_partido_jornada',
    season_id,
    matchday,
  });
}

export function analisisPartido(season_id, game_id) {
  dataLayer.push({
    event: 'analisis_partido',
    season_id,
    game_id,
  });
}

export function analisisPartidoSeccion(sectionName, season_id, game_id) {
  if (sectionName.length > 0) {
    dataLayer.push({
      event: `analisis_partido_${sectionName}`,
      season_id,
      game_id,
    });
  }
}

export function analisisPartidoDistribucionLiveVista(season_id, game_id, value) {
  dataLayer.push({
    event: 'analisis_partido_distribucion_live_vista',
    season_id,
    game_id,
    value,
  });
}

export function analisisPartidoTendenciaLiveEquipo(season_id, game_id, team_id) {
  dataLayer.push({
    event: 'analisis_partido_tendencia_live_equipo',
    season_id,
    game_id,
    team_id,
  });
}

export function analisisPartidoTendenciaLiveVista(season_id, game_id, value) {
  dataLayer.push({
    event: 'analisis_partido_tendencia_live_vista',
    season_id,
    game_id,
    value,
  });
}

export function analisisPartidosVolverVistaPartido(season_id, game_id) {
  dataLayer.push({
    event: 'analisis_partido_volver_a_vista_partidos',
    season_id,
    game_id,
  });
}

export function analisisPartidoFiltroTipoDeAnalisis(season_id, game_id, value) {
  dataLayer.push({
    event: 'analisis_partido_filtro_tipo_de_analisis',
    season_id,
    game_id,
    value,
  });
}

export function analisisPartidoFiltrosAvanzados(season_id, game_id) {
  dataLayer.push({
    event: 'analisis_partido_filtros_avanzados',
    season_id,
    game_id,
  });
}

export function analisisPartidosAplicarFiltros(season_id, game_id, value) {
  dataLayer.push({
    event: 'analisis_partido_aplicar_filtros',
    season_id,
    game_id,
    value,
  });
}

export function analisisPartidosCerrarFiltroAvanzando(season_id, game_id) {
  dataLayer.push({
    event: 'analisis_partido_cerrar_filtro_avanzado',
    season_id,
    game_id,
  });
}

export function analisisPartidoLive(season_id, game_id) {
  dataLayer.push({
    event: 'analisis_partido_live',
    season_id,
    game_id,
  });
}

export function analisisPartidoTendenciaLiveCategoria(season_id, game_id, value) {
  dataLayer.push({
    event: 'analisis_partido_tendencialive_categoria',
    season_id,
    game_id,
    value,
  });
}
